import { Form, Radio, Space } from "antd";
import { getConfigAppPartType } from "../../utils";
import { AppPartType } from "../../AppForm/types";
import { Styles } from "./styled";
interface IProps {
  isDisable?: boolean;
  preview?: boolean;
  item: AppPartType;
  parentItem?: AppPartType;
  style?: React.CSSProperties;
  isTable?: boolean;
  nameItem: string;
  styleColor?: React.CSSProperties;
}

const RadioButton = (props: IProps) => {
  const {
    item,
    isDisable,
    nameItem,
    style,
    preview,
    isTable,
    styleColor = {},
  } = props;
  const { isHiddenLabel, labelText } = getConfigAppPartType(item);
  const form = Form.useFormInstance();
  const value = form.getFieldValue(nameItem);
  const isShowOnlyValue = !preview && isTable && isDisable;
  return (
    <Styles
      style={style}
      id={item.id}
      key={item.id}
      className="radio-button"
      color={styleColor?.color}
      background={styleColor?.background}
    >
      <div className="value_text_container">{isShowOnlyValue && value}</div>
      <Form.Item
        hidden={isShowOnlyValue}
        label={
          isHiddenLabel ? (
            <div></div>
          ) : (
            <div className="no-wrap-text" title={labelText}>
              {labelText}
            </div>
          )
        }
        style={styleColor}
        name={nameItem}
      >
        <Radio.Group style={styleColor}>
          <Space
            direction={(item.item_config_data?.layout as any) || "horizontal"}
          >
            {(item.item_config_data?.options || []).map((option, i) => {
              return (
                <Radio key={option?.text} value={option?.text?.toString()}>
                  {option?.text}
                </Radio>
              );
            })}
          </Space>
        </Radio.Group>
      </Form.Item>
    </Styles>
  );
};
export default RadioButton;
